import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import defaultImg from './../../../images/task/img1.jpg';
import { var_api, image_api } from '../../../constant';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import jsPDF from "jspdf";

const ExpenseMaster = () => {
  const navigate = useNavigate();
  const tableHeaders = ["#", "Expense Voucher", "Expense", "Description", "Amount", "Expense Date", "Status", "Action"];
  const [expenseData, setExpenseData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({
    id: null,
    expense_id: "",
    warehouse_id: 1,
    proof_document: "",
    description: "",
    amount: "",
    expense_date: "", // ✅ New field
    active_status: 1,
    updated_by: localStorage.getItem("login_id")
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [expenseOptions, setExpenseOptions] = useState([]);

  //   // ✅ New state for date filter
   // ✅ Set today's date as default for filter
  const [filterDate, setFilterDate] = useState(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  });

  useEffect(() => {
    loadInitialData();
    fetchExpenseNameOptions();
  }, [filterDate]);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchExpenseData();
    } catch (error) {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF("p", "mm", "a4");
    doc.setFontSize(14);
    doc.text("Expense Report", 105, 15, { align: "center" });
    doc.setFontSize(10);
    doc.text("This document contains the expense details including names, dates, and amounts.", 10, 25);

    const tableColumn = ["#", "Expense Name", "Amount", "Expense Date"];
    const tableRows = [];

    expenseData.forEach((item, index) => {
      const expenseName = getExpenseNameById(item.expense_id);
      const row = [
        index + 1,
        expenseName,
        `${parseFloat(item.amount).toFixed(2)}`,
        item.expense_date ? item.expense_date : "-"
      ];
      tableRows.push(row);
    });

    let startY = 35;
    doc.setFontSize(10);
    tableColumn.forEach((col, i) => {
      doc.text(col, 10 + i * 45, startY);
    });
    startY += 5;

    tableRows.forEach(row => {
      row.forEach((cell, i) => {
        doc.text(String(cell), 10 + i * 45, startY);
      });
      startY += 7;
    });

    doc.save("Expense_Report.pdf");
  };

 
  const fetchExpenseData = async () => {
    const warehouse_id = localStorage.getItem("warehouse_id");
    
    try {
      let url = `${var_api}veemart_expenses/getByDate-warehouse/${warehouse_id}`;
      
      // ✅ Add date parameter if filterDate is selected
      if (filterDate) {
        // Format date as DD-MM-YYYY for the API
        const formattedDate = new Date(filterDate)
          .toLocaleDateString('en-GB')
          .split('/')
          .join('-');
        
        url += `/${formattedDate}`;
      }
      
      const res = await axios.get(url);
      setExpenseData(res.data.data || []);
      setCurrentPage(1); // Reset to first page when data changes
    } catch (error) {
      toast.error("Failed to fetch expense data");
      setExpenseData([]);
    }
  };

  const fetchExpenseNameOptions = async () => {
    const warehouse_id = localStorage.getItem("warehouse_id"); // Example warehouse ID
    try {
      const res = await axios.get(`${var_api}sa_veemart_expensename_master/getbywarehouse-active/${warehouse_id}`);
      if (res.data && Array.isArray(res.data)) {
        setExpenseOptions(res.data);
      }
    } catch (error) {
      toast.error("Failed to load expense name list");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "amount" && value < 0) {
      toast.warning("Amount cannot be negative");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleAddClick = () => {
    setFormData({
      id: null,
      expense_id: "",
      warehouse_id: 1,
      proof_document: "",
      description: "",
      amount: "",
      expense_date: "", // reset
      active_status: 1,
      updated_by: localStorage.getItem("login_id")
    });
    setFile(null);
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

 const handleEditClick = (item) => {
  // Convert DD-MM-YYYY → YYYY-MM-DD for input[type="date"]
  let formattedDate = "";
  if (item.expense_date && item.expense_date.includes("-")) {
    const [day, month, year] = item.expense_date.split("-");
    formattedDate = `${year}-${month}-${day}`;
  }

  setFormData({
    ...item,
    expense_date: formattedDate,
    warehouse_id: item.warehouse_id || 1,
  });
  setFile(null);
  setIsEditMode(true);
  setErrors({});
  setShowModal(true);
};


 const handleSubmit = async (e) => {
  e.preventDefault();
  const newErrors = {};

  if (!formData.expense_id) {
    newErrors.expense_id = "Expense Name is required";
  }
  if (formData.amount === "" || formData.amount < 0) {
    newErrors.amount = "Amount must be 0 or more";
  }
  if (!formData.expense_date) {
    newErrors.expense_date = "Expense Date is required";
  }

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    toast.warning("Please correct the highlighted fields");
    return;
  }

  try {
    setLoading(true);

    // ✅ Convert YYYY-MM-DD → DD-MM-YYYY
    const formattedDate = formData.expense_date
      ? new Date(formData.expense_date).toLocaleDateString("en-GB").split("/").join("-")
      : "";

    const form = new FormData();
    form.append("expense_id", formData.expense_id);
    form.append("warehouse_id", formData.warehouse_id);
    form.append("description", formData.description);
    form.append("amount", formData.amount);
    form.append("expense_date", formattedDate); // ✅ formatted date
    if (file) form.append("proof_document", file);
    form.append("active_status", formData.active_status);
      form.append("updated_by", formData.updated_by);

    const headers = { headers: { "Content-Type": "multipart/form-data" } };
    let res;

    if (isEditMode && formData.id) {
      res = await axios.put(`${var_api}veemart_expenses/update/${formData.id}`, form, headers);
    } else {
      res = await axios.post(`${var_api}veemart_expenses/post`, form, headers);
    }

    toast.success(res?.data?.message || "Expense saved successfully!");
    setShowModal(false);
    fetchExpenseData();
  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed to save expense");
  } finally {
    setLoading(false);
  }
};

  const getExpenseNameById = (id) => {
    const match = expenseOptions.find((exp) => exp.id === id);
    return match ? match.expense_name : "-";
  };

  const filteredData = expenseData?.filter(item =>
    Object.values(item).some(val => String(val).toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">
                  <i className="fas fa-credit-card"></i> Expenses
                </h5>
                <div className="d-flex align-items-center gap-2">
                  {/* <Button variant="outline-success" onClick={() => navigate("/expense-master")} title="Go to Expense Master">
                    <i className="fas fa-external-link-alt"></i>
                  </Button> */}
                  {/* <Button variant="outline-primary" onClick={handleDownloadPDF}>
                    <i className="fas fa-file-pdf"></i> Download PDF
                  </Button> */}

                  <Form.Control
                    type="date"
                    value={filterDate}
                    onChange={(e) => setFilterDate(e.target.value)}
                    style={{ width: "200px" }}
                  />

                  <input
                    type="text"
                    className="form-control w-auto"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                  <Button variant="secondary" onClick={handleAddClick}>Add</Button>
                </div>

                 
                
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>{tableHeaders.map((header, idx) => (<th key={idx}>{header}</th>))}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center text-muted py-3">No data found</td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>
                            <img
                              src={item.proof_document ? `${image_api}${item.proof_document.replace(/^test\//, '')}` : defaultImg}
                              alt="proof"
                              width="40"
                              height="40"
                              className="rounded"
                              onClick={() => window.open(`${image_api}${item.proof_document.replace(/^test\//, '')}`, '_blank')}
                              style={{ cursor: 'pointer' }}
                            />
                          </td>
                          <td>{getExpenseNameById(item.expense_id)}</td>
                          <td>{item.description}</td>
                          <td>₹ {parseFloat(item.amount).toFixed(2)}</td>
<td>
  {item.expense_date
    ? item.expense_date // already in DD-MM-YYYY format
    : "-"}
</td>

                          <td>
                            <span className={`badge ${item.active_status === 1 || item.active_status === 'Active' ? 'bg-success' : 'bg-danger'}`}>
                              {item.active_status === 1 || item.active_status === 'Active' ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td>
                            <Link
                              to="#"
                              className="btn shadow btn-xs sharp me-1"
                              style={{ backgroundColor: "#007bff", color: "white" }}
                              onClick={() => handleEditClick(item)}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>

        {/* Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Expense" : "Add Expense"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Expense Name <span className="text-danger">*</span></Form.Label>
                    <Select
                      options={expenseOptions.map((exp) => ({
                        value: exp.id,
                        label: exp.expense_name,
                      }))}
                      value={
                        expenseOptions
                          .map((exp) => ({ value: exp.id, label: exp.expense_name }))
                          .find((opt) => opt.value === formData.expense_id) || null
                      }
                      onChange={(selected) => {
                        setFormData((prev) => ({
                          ...prev,
                          expense_id: selected ? selected.value : "",
                        }));
                        if (selected) {
                          setErrors((prev) => ({ ...prev, expense_id: "" }));
                        }
                      }}
                      placeholder="Select Expense Name"
                      isClearable
                    />
                    {errors.expense_id && <div className="text-danger small mt-1">{errors.expense_id}</div>}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Expense Date <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="date"
                      name="expense_date"
                      value={formData.expense_date}
                      onChange={handleInputChange}
                    />
                    {errors.expense_date && <div className="text-danger small mt-1">{errors.expense_date}</div>}
                  </Form.Group>
                </Col>

              
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Amount <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="number"
                      name="amount"
                      min="0"
                      value={formData.amount}
                      placeholder="Enter amount"
                      onChange={handleInputChange}
                    />
                    {errors.amount && <div className="text-danger small mt-1">{errors.amount}</div>}
                  </Form.Group>
                </Col>

                  <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={formData.description}
                      placeholder="Enter remarks"
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>


                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Proof Document</Form.Label>
                    {isEditMode && formData.proof_document && !file && (
                      <div className="mb-2 d-flex gap-2 align-items-center">
                        <img
                          src={`${image_api}${formData.proof_document.replace(/^test\//, '')}`}
                          alt="Preview"
                          width="80"
                          className="rounded border"
                        />
                      </div>
                    )}
                    <Form.Control type="file" accept="image/*" onChange={(e) => setFile(e.target.files[0])} />
                  </Form.Group>
                </Col>

                {isEditMode && (
                  <Col md={6}>
                    <Form.Group className="mb-2 d-flex align-items-center gap-2">
                      <Form.Label className="mb-0">
                        {formData.active_status === 1 || formData.active_status === 'Active' ? "Active" : "Inactive"}
                      </Form.Label>
                      <Form.Check
                        type="switch"
                        id="active-status-switch"
                        checked={formData.active_status === 1 || formData.active_status === 'Active'}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            active_status: e.target.checked ? 1 : 0,
                          })
                        }
                        className={
                          formData.active_status === 1 || formData.active_status === 'Active'
                            ? "custom-switch-green"
                            : ""
                        }
                      />
                    </Form.Group>
                  </Col>
                )}
              </Row>

              <div className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <>
                    <Button variant="secondary" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Creating...
                        </>
                      ) : (
                        "Create"
                      )}
                    </Button>
                    <Button
                      variant="danger"
                      type="reset"
                      disabled={loading}
                      onClick={() =>
                        setFormData({
                          id: null,
                          expense_id: "",
                          warehouse_id: 1,
                          proof_document: "",
                          description: "",
                          amount: "",
                          expense_date: "",
                          active_status: 1,
                        })
                      }
                    >
                      Reset
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="warning" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Updating...
                        </>
                      ) : (
                        "Update"
                      )}
                    </Button>
                    <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
                      Cancel
                    </Button>
                  </>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </Card>

      <style>{`
        .custom-switch-green .form-check-input:checked {
          background-color: #28a745 !important;
          border-color: #28a745 !important;
        }
      `}</style>
      <ToastContainer />
    </>
  );
};

export default ExpenseMaster;
